<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
        <div class="topo-index">
          <h1>Acompanhamento de Demandas de Conselhos</h1>
          <router-link :to="{ name: 'AcompanhamentoNew' }" v-if="isAdmin">
            <span>+</span> Novo Acompanhamento
          </router-link>
        </div>
        <div class="caixa-pesquisa">
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="fazerBusca" v-if="!exibirPesquisa">
              <div class="row2-data">
                <div class="item">
                  <label>Nome:</label>
                  <input type="text" placeholder="Digite o nome do membro (Indicado ou Destituído)" v-model="filtro.nome" />
                </div>
                <div class="item item-cpf">
                  <label>CPF do Membro:</label>
                  <the-mask :mask="['###.###.###-##']" placeholder="000.000.000-00" v-model="filtro.cpf" />
                </div>
                <div class="item">
                  <label>Processo SEI:</label>
                  <input type="text" placeholder="Digite o número do Processo SEI" v-model="filtro.processo_sei" />
                </div>
                <div class="item">
                  <label for="selectedOrgao">Órgão:</label>
                  <v-select
                    class="vselect" 
                    v-model="selectedOrgao" 
                    id="selectedOrgao" 
                    :options="paginated"
                    label="nome" 
                    placeholder="Todos"
                    :filterable="false" 
                    @search="onSearch">
                    <li slot="list-footer" class="pagination">
                      <button :disabled="!hasPrevPage" @click.prevent="offset -= limit">Anterior</button>
                      <button :disabled="!hasNextPage" @click.prevent="offset += limit">Próxima</button>
                    </li>
                  </v-select>
                </div>
                
                <div class="item">
                  <label>Tipo de Movimentação:</label>
                  <div class="radio-container">
                    <label class="radio-label">
                      <input type="radio" v-model="filtro.tipo_movimentacao" value="indicacao" class="radio-input">
                      Indicação
                    </label>
                    <label class="radio-label">
                      <input type="radio" v-model="filtro.tipo_movimentacao" value="destituicao" class="radio-input">
                      Destituição
                    </label>
                    <label class="radio-label">
                      <input type="radio" v-model="filtro.tipo_movimentacao" value="substituicao" class="radio-input">
                      Substituição
                    </label>
                    <label class="radio-label">
                      <input type="radio" v-model="filtro.tipo_movimentacao" value="exoneracao" class="radio-input">
                      Exoneração
                    </label>
                    <label class="radio-label">
                      <input type="radio" v-model="filtro.tipo_movimentacao" value="reconducao" class="radio-input">
                      Recondução
                    </label>
                  </div>
                </div>
                
                <div class="item checkbox-status" style="margin-top: 0.5rem;">
                  <label>Status:</label>
                  <div class="opcoes-status">
                    <label>
                      <input type="checkbox" v-model="filtroStatus.acompanhando">
                      Em andamento
                    </label>
                    <label>
                      <input type="checkbox" v-model="filtroStatus.concluido">
                      Concluído
                    </label>
                  </div>
                </div>

              </div> 
              
              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="submit">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button title="Limpar" @click.prevent="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultados }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="container-tabela">
          <TabelaResultadosAcompanhamento 
            :acompanhamentos="acompanhamentos" 
            :permissoes="permissoes" 
            :acompanhamento="acompanhamento"
            :ordenacaoExterna="{ coluna: filtro.ordenar_por, ordem: filtro.ordem }"
            @ordenar="aplicarOrdenacaoExterna"
            v-if="!carregando && !erro">
          </TabelaResultadosAcompanhamento>
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
          :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
          active-class="active-page"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import tryParseInt from "../../helpers/tryParseInt.js";
import metaDados from "../../helpers/metaDados.js";  
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Auth from "../../services/Auth";

import AcompanhamentoApi from "../../services/AcompanhamentoApi.js";
import MsgErroFormularios from "../../components/MsgErroFormularios.vue";
import TabelaResultadosAcompanhamento from "../../components/acompanhamento/TabelaResultadosAcompanhamento.vue";

export default {
  name: "Acompanhamentos",
  metaInfo() {
    return {
      title: "Acompanhamentos",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        { vmid: "description", name: "description", property: "description", content: "Página de acesso e pesquisa de todos os acompanhamentos realizados." },
        { vmid: "og:description", property: "og:description", content: "Página de acesso e pesquisa de todos os acompanhamentos realizados." },
        { vmid: "og:title", property: "og:title", content: "Acompanhamentos - Casa Civil do Estado de Goiás" },
        ...metaDados(this.$route),
      ],
    };
  },
  data() {
    return {
      acompanhamentos: [],
      acompanhamento: null,
      carregando: true,
      orgaos: [],
      selectedOrgao: null,
      search: '',
      offset: 0,
      limit: 10,
      msgErros: { acompanhamento: '' },
      erro: false,
      totalResultados: null,
      pagina: 1,
      qtd_por_pagina: 10,
      filtro: {
        nome: null,
        cpf: null,
        processo_sei: null,
        obs_acompanhamento: null,
        colegiado_id: null,
        conselho_id: null,
        tipo_movimentacao: null,
        ordenar_por: null,
        ordem: null
      },
      filtroStatus: {
        acompanhando: true,
        concluido: false
      },
      permissoes: {
        pode_visualizar: true,
        pode_criar: true,
        pode_editar: true,
        pode_deletar: true
      },
      exibirPesquisa: true,
      carregandoFiltro: false,
      erroFiltro: false,
      optionsOrgaos: [],
    };
  },
  components: {
    MsgErroFormularios,
    Paginate,
    vSelect,
    TabelaResultadosAcompanhamento
  },
  created() {
    this.acompanhamentoApi = new AcompanhamentoApi();
    this.carregarQtdPorPagina();
    this.sincronizarStatusDaUrl(this.$route.query);
    this.carregarValoresFiltro();
    this.carregarAcompanhamentos();
  },
  watch: {
    $route: function (to, from) {
      const mudouQuery =
        to.query.pagina != from.query.pagina ||
        to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
        to.query.colegiado_id != from.query.colegiado_id ||
        to.query.tipo_movimentacao != from.query.tipo_movimentacao ||
        to.query.processo_sei != from.query.processo_sei ||
        to.query.obs_acompanhamento != from.query.obs_acompanhamento ||
        to.query.cpf != from.query.cpf ||
        to.query.nome != from.query.nome ||
        to.query.ordenar_por != from.query.ordenar_por ||
        to.query.ordem != from.query.ordem ||
        to.query.status != from.query.status ||
        to.query.acompanhando != from.query.acompanhando ||
        to.query.concluido != from.query.concluido;

      if (from.name == "Acompanhamentos" && to.name == "Acompanhamentos" && mudouQuery) {
        this.sincronizarStatusDaUrl(to.query);
        this.carregarValoresFiltro();
        this.carregarAcompanhamentos();
      }
    },
  },
  methods: {
    aplicarOrdenacaoExterna(ordenacao) {
      this.filtro.ordenar_por = ordenacao.coluna;
      this.filtro.ordem = ordenacao.ordem;
      this.fazerBusca(); 
    },
    fecharErro() {
      this.erro = false;
    },    
    tooglePesquisa: function () {
      this.exibirPesquisa = !this.exibirPesquisa;
    },
    onSearch(query) {
      this.search = query;
      this.offset = 0;
    },
    setarOptions() {
      this.optionsOrgaos = this.orgaos.map(orgao => ({
        id: orgao.id,
        nome: orgao.nome
      }));
    },
    fazerBusca() {
      const parametrosBusca = {
        ...this.filtro,
        status: this.statusSelecionado(),
        pagina: 1,
        qtd_por_pagina: this.qtd_por_pagina,
      };

      // # Se o Select ainda carrega "getColegiados", ele está buscando pelo "Conselho" do membro
      if (this.selectedOrgao) { 
        parametrosBusca.colegiado_id = this.selectedOrgao.id; 
      } else {
        parametrosBusca.colegiado_id = null; 
      }

      this.$router.push({ name: "Acompanhamentos", query: parametrosBusca }).catch(()=>{});
    },
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil((this.qtd_por_pagina * this.pagina) / novaQtdPagina);
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    sincronizarStatusDaUrl(query) {
      const status = query.status;
      if (status === "acompanhando") {
        this.filtroStatus = { acompanhando: true, concluido: false };
      } else if (status === "concluido") {
        this.filtroStatus = { acompanhando: false, concluido: true };
      } else if (status === "todos") {
        this.filtroStatus = { acompanhando: true, concluido: true };
      } else if (status === "nenhum") {
        this.filtroStatus = { acompanhando: false, concluido: false };
      } else if (query.acompanhando != null || query.concluido != null) {
        this.filtroStatus = {
          acompanhando: query.acompanhando == null
            ? query.concluido !== "true"
            : query.acompanhando === "true",
          concluido: query.concluido === "true"
        };
      } else {
        this.filtroStatus = { acompanhando: true, concluido: false };
      }
    },
    statusSelecionado() {
      if (this.filtroStatus.acompanhando && this.filtroStatus.concluido) return "todos";
      if (this.filtroStatus.acompanhando) return "acompanhando";
      if (this.filtroStatus.concluido) return "concluido";
      return "nenhum";
    },
    mudouPagina: function (page) {
      this.pagina = page;
      const filtroAtual = {
        colegiado_id: this.getParam("colegiado_id"), 
        tipo_movimentacao: this.getParam("tipo_movimentacao"),
        nome: this.getParam("nome"),
        cpf: this.getParam("cpf"),
        processo_sei: this.getParam("processo_sei"),
        obs_acompanhamento: this.getParam("obs_acompanhamento"),
        ordenar_por: this.getParam("ordenar_por"),
        ordem: this.getParam("ordem"),
        status: this.statusSelecionado()
      };

      this.$router.push({
        name: "Acompanhamentos",
        query: {
          ...filtroAtual,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
        },
      }).catch(()=>{});
    },
    async carregarValoresFiltro() {
      try {
        if (this.carregandoFiltro && !this.erroFiltro) return;
        this.erroFiltro = false;        
        
        // Alterado para carregar as Categorias Representativas (Órgãos) assim como no formulário
        const response = await this.acompanhamentoApi.getOrgaosOrigem();
        
        // Tratamento da resposta para garantir que extrai o array correto
        let listaCategorias = response.resultados || response.categorias_representativas || response.data || response || [];
        
        this.orgaos = listaCategorias;
        
        this.orgaos.map((orgao) => {
          if (orgao.sigla !== undefined && orgao.sigla !== '') {
            orgao.nome = orgao.sigla + " - " + orgao.nome;
          }
        });
        const orgaoUrlId = this.getParam("colegiado_id");
        if (orgaoUrlId) {
          this.selectedOrgao = this.orgaos.find(o => o.id == orgaoUrlId);
        }
      } catch (err) {
        this.erroFiltro = true; 
        console.error("Erro ao carregar órgãos para o filtro", err);
      }
      this.setarOptions();
    },
    async carregarAcompanhamentos() {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;
        this.armazenarQtdPorPagina();
        const pagina = this.getParam("pagina") || 1;
        this.pagina = parseInt(pagina);

        this.filtro = {
          colegiado_id: this.getParam("colegiado_id"),
          nome: this.getParam("nome"),
          cpf: this.getParam("cpf"),
          processo_sei: this.getParam("processo_sei"),
          obs_acompanhamento: this.getParam("obs_acompanhamento"),
          tipo_movimentacao: this.getParam("tipo_movimentacao"),
          ordenar_por: this.getParam("ordenar_por"),
          ordem: this.getParam("ordem"),
          status: this.statusSelecionado(),
        };

        if (this.acompanhamentoApi.cancelTokens.getAcompanhamentos) {
          this.acompanhamentoApi.cancelTokens.getAcompanhamentos.cancel();
        }

        let data = await this.acompanhamentoApi.getAcompanhamentos({
          ...this.filtro,
          qtd_por_pagina: this.qtd_por_pagina,
          page: this.pagina,
        });
        
        this.acompanhamentos = data.acompanhamentos || data.resultados || []; 
        this.permissoes = data.permissoes || this.permissoes;
        this.permissoes.pode_editar = this.isAdmin;
        this.permissoes.pode_deletar = this.isAdmin;
        this.totalResultados = data.total_resultados || 0;
        
      } catch (err) {
        console.error("Erro ao carregar acompanhamentos:", err);
        this.erro = true;
        this.msgErros.acompanhamento = "Não foi possível carregar os acompanhamentos.";
        this.acompanhamentos = []; 
      } finally {
        this.carregando = false;
      }
    },
    limparFiltro: function () {
      this.filtro = {
        nome: null,
        cpf: null,
        processo_sei: null,
        obs_acompanhamento: null,
        colegiado_id: null,
        tipo_movimentacao: null,
        ordenar_por: null,
        ordem: null
      };
      this.selectedOrgao = null;
      this.fazerBusca(); // Dispara a busca vazia para recarregar todos os dados
    },
    armazenarQtdPorPagina() { 
      localStorage.setItem("qtd_por_pagina_acompanhamentos", this.qtd_por_pagina);
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_acompanhamentos");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados != undefined &&
        this.totalResultados != null &&
        this.qtd_por_pagina != null &&
        this.qtd_por_pagina != undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
    filtered() {
      return this.orgaos.filter((orgao) =>
        orgao.nome.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    paginated() {
      return this.filtered.slice(this.offset, this.limit + this.offset)
    },
    hasNextPage() {
      const nextOffset = this.offset + this.limit
      return Boolean(this.filtered.slice(nextOffset, this.limit + nextOffset).length)
    },
    hasPrevPage() {
      const prevOffset = this.offset - this.limit
      return Boolean(this.filtered.slice(prevOffset, this.limit + prevOffset).length)
    },
    isAdmin() { 
      const auth = new Auth();
      const usuario = auth.usuario;
      
      // Verifica se o usuário tem a permissão exata de criar/editar
      if (usuario && usuario.funcionalidades) {
        return usuario.funcionalidades.includes('acompanhamentos_new_edit_delete');
      }
      return false;
    }
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-status {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    label {
      align-items: center;
      display: flex;
      gap: 0.5rem;
      font-family: "Karla", sans-serif;
      font-size: 14.4px;
    }

    .opcoes-status {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }
  }

  /* Remove as setas de aumento e diminuição do input tipo "number" */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .item-cpf {
          max-width: 990px; /* Trava o tamanho SÓ do CPF ligado ao nome */
        }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .center {
    align-self: center;
  }
  .radio-container {
    display: flex;
    gap: 1rem;
  }
  .radio-label {
    display: flex;
    gap: .5rem;
    align-items: center;
  }
  .label-container {
    display: flex;
  }
  .custom-label {
    margin-right: 70px; 
}
  .input-container {
    display: flex;
    align-items: center;
                }


                .input-wrapper input {
                    width: 100px; 
                    margin-right: 10px; 
                }

                .input-wrapper1 input {
                    width: 100px; 
                    margin-right: 110px; 
                }

                .input-wrapper2 input {
                    width: 100px; 
                    margin-right: 10px; 
                }

                .input-wrapper3 input {
                    width: 100px; 
                    margin-right: 10px; 
                }
@media screen and (min-width: "1066px") {
  .div-conteudo {
    width: 100vw;

    .centro {
      max-width: 96vw;
      margin: 0 auto;
    }

    
    .index {
      .topo-index {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        h1 {
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          color: #ffa600;
          font-size: 1.8rem;
        }

        a {
          color: #005516;
          text-decoration: none;
          font-family: "Montserrat-Medium";
          border: #005516 solid 0.15rem;
          padding: 0.2rem 1rem;
          border-radius: 0.2rem;
          transition: 0.2s;
          margin-bottom: 1.5rem;
          margin-top: 1.5rem;

          span {
            font-family: "Montserrat-Bolder";
          }
        }

        a:hover {
          color: white;
          background-color: #005516;
        }
      }

      .caixa-pesquisa {
        background-color: #ededed;
        padding: 1rem;
        border-radius: 1rem 1rem 0 0;
        .flex {
          display: inline-flex;
          gap: 1rem;
          margin: 1rem 0 0 0;
        }
        .row4 {
          display: grid;
          grid-template-columns: .25fr .25fr .25fr .25fr;
          gap: 1rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
          
        }

        .row2 {
          display: grid;
          grid-template-columns: .5fr .5fr;
          gap: 1rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
        }

        .row2-data {
          display: grid;
          grid-template-columns: repeat(2, 1fr); 
          gap: 1.5rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
        }

        input {
          border-radius: 0.5rem;
          border: solid 0.1rem;
        }

        h2 {
          margin: 0;
          text-transform: uppercase;
          color: #005516;
          font-size: 1.2rem;
          font-family: "Montserrat-Medium";
          font-weight: bold;
          cursor: pointer;
        }

        .item {
          display: grid;
          margin: .5rem 0 .5rem 0;

          label {
            width: fit-content;
            margin-bottom: 0.3rem;
            color: black;
            font-family: "Karla", sans-serif;
            font-size: 0.95rem;
            font-weight: 500;
          }

          input {
            height: 2rem;
            font-family: "Montserrat-Medium";
            padding-left: 0.5rem;
            font-size: 0.9rem;
          }

          select {
            height: 2rem;
            border-radius: 0.5rem;
            border: solid 0.1rem;
            background-color: white;
            font-family: "Montserrat-Medium";
            font-size: 0.84rem;
          }
        }

        .botoes-pesquisa {
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;

          .bt-pesquisa {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #005516;
              color: white;
              border: #005516 solid 0.15rem;
              font-size: 1rem;
              padding: 0.3rem 2rem;
              border-radius: 2rem;

              img {
                height: 1rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }

          .bt-limpar {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #FFFFFF;
              color: #000;
              border: white solid 0.15rem;
              font-size: 1rem;
              padding: 0.3rem 2rem;
              border-radius: 2rem;

              img {
                height: 1.5rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .n-div {
        display: flex;
        justify-content: space-between;

        .nresultados {
          margin: 0.5rem 0.5rem 0.5rem 0.5rem;

          label {
            color: #005516;
            font-size: 0.9rem;
            font-family: "Montserrat-Bold";
            margin-top: 0.5rem;
          }
        }

        .npagina {
          margin: 0.5rem 0.5rem 0.5rem 0.5rem;

          label {
            color: #005516;
            font-size: 0.9rem;
            font-family: "Montserrat-Medium";
            margin: 0.5rem .5rem 0 0;
          }

          select {
            border: none;
            background-color: #edf2ee;
            font-size: 0.9rem;
            margin-top: 0.5rem;
            cursor: pointer;
          }
        }
      }

      .container-tabela {
        margin-top: .5rem;
        border-radius: 1.5rem;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

        .resultados {
          width: 100%;
          height: max-content;
          margin: 0;
        }
      }
    }
  }
}

@media screen and (min-width: "60px") and (max-width: "1065px") {
  .div-conteudo {
    width: 100vw;

    .centro {
      width: 90vw;
      margin: 0 auto;
    }

    .index {
      .topo-index {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        h1 {
          font-family: "Montserrat-Medium";
          font-weight: bold;
          color: #ffa600;
          font-size: 1.8rem;
        }

        a {
          color: #005516;
          text-decoration: none;
          font-family: "Montserrat-Medium";
          border: #005516 solid 0.15rem;
          padding: 0.2rem 1rem;
          border-radius: 0.2rem;
          transition: 0.2s;
          margin-bottom: 1.5rem;
          margin-top: 1.5rem;

          span {
            font-family: "Montserrat-Bolder";
          }
        }

        a:hover {
          color: white;
          background-color: #005516;
        }
      }

      .caixa-pesquisa {
        background-color: #ededed;
        padding: 1rem;
        border-radius: 1rem 1rem 0 0;

        .row4-data {
          display: flex;
          justify-content: space-between;
          gap: 1.5rem;

          .item {
            width: -webkit-fill-available;
          }
        }

        input {
          border-radius: 0.5rem;
          border: solid 0.1rem;
        }

        h2 {
          margin: 0;
          text-transform: uppercase;
          color: #005516;
          font-size: 1.2rem;
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          cursor: pointer;
        }

        .item {
          display: grid;
          margin: .5rem 0 .5rem 0;

          label {
            width: fit-content;
            margin-bottom: 0.3rem;
            color: black;
            font-family: "Karla", sans-serif;
            font-size: 0.95rem;
            font-weight: 500;
          }

          input {
            height: 2rem;
            font-family: "Montserrat-Medium";
            padding-left: 0.5rem;
            font-size: 0.9rem;
          }

          select {
            height: 2rem;
            border-radius: 0.5rem;
            border: solid 0.1rem;
            background-color: white;
            font-family: "Montserrat-Medium";
            font-size: 0.84rem;
          }
        }

        .botoes-pesquisa {
          display: grid;
          gap: 1rem;
          place-content: center;
          margin-top: 1rem;

          .bt-pesquisa {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #005516;
              color: white;
              border: #005516 solid 0.15rem;
              font-size: 1rem;
              padding: 0.2rem 1rem;
              border-radius: 2rem;

              img {
                height: 1rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }

          .bt-limpar {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #FFFFFF;
              color: #000;
              border: white solid 0.15rem;
              font-size: 1rem;
              padding: 0.3rem 2rem;
              border-radius: 2rem;

              img {
                height: 1.5rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .n-div {
        display: flex;
        justify-content: space-between;

        .nresultados {
          margin: 0.5rem 0.5rem 0.5rem 0.5rem;

          label {
            color: #005516;
            font-size: 0.8rem;
            font-family: "Montserrat-Bold";
            margin-top: 0.5rem;
          }
        }

        .npagina {
          margin: 0.5rem 0.5rem 0.5rem 0.5rem;
          text-align: end;

          label {
            color: #005516;
            font-size: 0.8rem;
            font-family: "Montserrat-Medium";
            margin: 0.5rem .5rem 0 0;
          }

          select {
            border: none;
            background-color: #edf2ee;
            font-size: 0.9rem;
            margin-top: 0.5rem;
            cursor: pointer;
          }
        }
      }

      .container-tabela {
        margin-top: .5rem;
        border-radius: 1.5rem;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

        .resultados {
          width: 100%;
          height: max-content;
          margin: 0;
        }
      }
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: fit-content;
  height: 0px auto;
  margin: 0px auto;
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
  font-size: 1.5rem;
  font-family: "Montserrat-Medium";

  img {
    width: 2rem;
    height: 2rem;
    margin-right: 1.6rem;
  }

  label {
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.556);
    display: inline;
    position: relative;
    top: 0rem;
  }
}
.vselect {
  background-color: #fff;
  border-radius: 0.5rem; 

  ::v-deep .vs__dropdown-toggle {    
    padding: 0 0 2px 0; 
    min-height: 2rem;
    height: 2rem;    
    border: solid 0.1rem #414040; 
    border-radius: 0.5rem;
    transition: border-color 0.15s ease-in-out;

    &:hover, &:focus-within {
      border-color: #005516;
    }
  }
  
  ::v-deep .vs__search {
    margin: 0;
    padding: 0 7px;
    height: 1.8rem;
    font-family: "Montserrat-Medium";
    font-size: 0.9rem;
  }
  
  ::v-deep .vs__selected {
    margin: 0;
    padding: 0 7px;
    line-height: 1.8rem;
    font-family: "Montserrat-Medium";
    font-size: 0.9rem;
  }
  
  ::v-deep .vs__actions {
    padding: 0 6px 0 3px;
  }
}
</style>